<template>
    <div class="control-block control-block-slider">
      <!--
        Note: IE11対応
        (input)だけではなく(change)も指定、inputの横幅をstyleで指定。
      -->
      <label><span>範囲</span><input type="range" name="range" max="5000" min="500" step="500"
                      style="max-width: 100%;"
                      class="control-block-slider"
                      v-bind:value="sharedState.circleRange"
                      @mouseup="onChange($event)"
                      @touchend="onChange($event)"
                      @keyup="onChange($event)"
      ></label>
    </div>
</template>

<script>
export default {
    name: "circle-range-control",
    data () {
        return {
        }
    },
    methods: {
        onChange (eve) {
            // マーカーの下の円の大きさを変える
            if (this.sharedState.circleRange != null) {
                this.$store.commit('updateCircleRenge', eve.target.value);
            }
        }
    },
    computed: {
        sharedState () {
            return this.$store.state
        },
        circleRange () {
            return this.$store.state.circleRange
        },
    },
    watch: {
        circleRange() {
            if (this.sharedState.circle != null) {
                this.$store.commit('updateCircle');
            }
        }
    },
}
</script>

<style>
/* control-blockのレンジスライダー設定　*/
.control-block-slider span {
  display: block;
  padding: 1em 0 .5em;
}
.control-block-slider input[type=range] {
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
  width: 100%;
}
.control-block-slider input[type=range]:focus {
  outline: none;
}
.control-block-slider input[type=range]::-webkit-slider-runnable-track {
  width: 90%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  background: #cccccc;
  border-radius: 3px;
  border: 1px solid #999;
}
.control-block-slider input[type=range]::-webkit-slider-thumb {
  box-shadow: 0 1px 2px #999;
  border: 1px solid #555;
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #eee;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -10px;
}
@supports (-ms-ime-align: auto) {
  .control-block-slider input[type=range]::-webkit-slider-thumb {
    margin-top: 0 !important;
  }
}
.control-block-slider input[type=range]:focus::-webkit-slider-runnable-track {
  background: #999999;
}
.control-block-slider input[type=range]::-moz-range-track {
  width: 90%;
  height: 3px;
  cursor: pointer;
  animate: 0.2s;
  background: #cccccc;
  border-radius: 3px;
  border: 1px solid #999;
}
.control-block-slider input[type=range]::-moz-range-thumb {
  box-shadow: 0 1px 2px #999;
  border: 1px solid #555;
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #eee;
  cursor: pointer;
}
.control-block-slider input[type=range]::-ms-track {
  width: 90%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}
.control-block-slider input[type=range]::-ms-fill-lower {
  background: #cccccc;
  border: 1px solid #999;
  border-radius: 3px;
}
.control-block-slider input[type=range]::-ms-fill-upper {
  background: #cccccc;
  border: 1px solid #999;
  border-radius: 3px;
}
.control-block-slider input[type=range]::-ms-thumb {
  box-shadow: 0 1px 2px #999;
  border: 1px solid #555;
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #eee;
  cursor: pointer;
}
.control-block-slider input[type=range]:focus::-ms-fill-lower {
  background: #999999;
}
.control-block-slider input[type=range]:focus::-ms-fill-upper {
  background: #999999;
}
.control-block-slider input[type=range]::-ms-tooltip {
  display: none;
}
</style>